import ThemeStore from '../schema/ThemeStore';
import { BASE_THEME_ID } from '../constants/themeConstants';
import { createStore } from 'satcheljs';
import { DARK_MODE_ACCESSIBILITY_BUG_FIX_EDGE_VERSION } from '../utils/dynamicModeChange';
import { isCurrentMajorVersionViable } from 'mini-common-utils/lib/utils/isCurrentMajorVersionViable';
import { ObservableMap } from 'mobx';
import { ThemeResources } from '../schema/ThemeResources';

const INIT_STORE: ThemeStore = {
    themeId: BASE_THEME_ID,
    themeData: new ObservableMap<string, ThemeResources>({
        [BASE_THEME_ID]: require('../resources/fabric.color.variables.theme.base.json'),
    }),
    darkMode: isCurrentMajorVersionViable(DARK_MODE_ACCESSIBILITY_BUG_FIX_EDGE_VERSION)
        ? window.matchMedia?.('(prefers-color-scheme: dark)').matches
        : false,
};
export const store = createStore<ThemeStore>('themeStore', INIT_STORE)();
